import { useEffect } from 'react';
import Table from '../Table';
import { useTranslation } from 'react-i18next';
/**
 * Componente que renderiza as fases do relatório
 * Suporta diferentes tipos de fase (form e camera)
 *
 * @component
 * @param {Object} props
 * @param {Array} props.phases - Array de fases do relatório
 * @param {boolean} props.editing - Indica se está em modo de edição
 * @param {Function} props.onValueChange - Callback para alterações nos valores
 * @param {Function} props.unit - Unidade de medida para campos de leitura
 */
const ContentPhases = ({ phases, editing, onValueChange, validation }) => {
  const { t } = useTranslation();

  // Processa fases do tipo form
  const renderFormPhase = (phase, phaseIndex) => {
    return (
      <Table
        key={phaseIndex}
        title={phase.title}
        editing={editing}
        content={phase.fields.map((field, fieldIndex) => ({
          title: field.label,
          value: field.userGivenValue
            ? Array.isArray(field.userGivenValue)
              ? field.userGivenValue.length > 0
                ? field.userGivenValue.join(', ')
                : field.userGivenValue[0]
              : field.userGivenValue
            : '-',
          type: field.type,
          choices: field.choices || field.options,
          index: fieldIndex,
          valid: field.isGoodToGo,
        }))}
        onValueChange={(fieldIndex, newValue) => onValueChange(phaseIndex, fieldIndex, newValue)}
      />
    );
  };

  const mapMeggerContent = (step, stepIndex) => {
    return {
      title: step.title,
      value: {
        reading: { value: step.imageAnalysis?.reading },
        reading_unit: {
          value: step.imageAnalysis?.reading_unit,
          type: 'select',
          choices: validation.unit?.values?.map((u) => {
            return { id: u.symbol, label: u.symbol };
          }),
        },
      },
      valid: step.valid,
      index: stepIndex,
    };
  };

  const mapHipotContent = (step, stepIndex) => {
    return validation.expected
      .map((v) => {
        if (v.key !== 'operator')
          return {
            title: t(v.key),
            value: step.imageAnalysis[v.key] ?? '',
            valid: v.key === 'time_count' ? step.valid : true,
            index: stepIndex,
            key: v.key,
          };
      })
      .filter((item) => Boolean(item));
  };

  // Processa fases do tipo camera
  const renderCameraPhase = (phase, phaseIndex) => {
    const content = phase.steps
      .map((step, stepIndex) => {
        if (step.imageAnalysis) {
          if (
            validation.expected.some((v) => v.key === 'reading') &&
            validation.expected.some((v) => v.key === 'reading_unit')
          ) {
            return mapMeggerContent(step, stepIndex);
          }
          return mapHipotContent(step, stepIndex);
        }
      })
      .filter((item) => Boolean(item))
      .flat();
    return (
      content.length > 0 && (
        <Table
          key={phaseIndex}
          title={phase.title}
          editing={editing}
          content={content}
          onValueChange={(fieldIndex, newValue, field) =>
            onValueChange(phaseIndex, fieldIndex, newValue, field)
          }
        />
      )
    );
  };

  return phases.map((phase, phaseIndex) => {
    if (phase.type === 'form') return renderFormPhase(phase, phaseIndex);
    if (phase.type === 'camera' || phase.type === 'evidency')
      return renderCameraPhase(phase, phaseIndex);
    return null;
  });
};

export default ContentPhases;
